import { useSortable } from '@dnd-kit/sortable';
import { Form } from 'antd';
import { CSS } from '@dnd-kit/utilities';
import '../TaskTable.scss';
import React from 'react';

export interface EditableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  index: number;
  'data-row-key': string;
}

export const EditableRow: React.FC<EditableRowProps> = React.memo(({ index, ...props }) => {
  const [form] = Form.useForm();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props['data-row-key'],
    data: {
      type: 'Task',
      task: props,
    },
  });

  const style: React.CSSProperties = {
    ...props.style,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    transition,
    cursor: 'move',
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  // Create drag handle event listeners that ignore dropdown areas
  const handleMouseDown = (event: React.MouseEvent) => {
    // Check if the event target is within a dropdown area
    const target = event.target as HTMLElement;
    let element = target;

    // Traverse up the DOM tree to check for dropdown-related elements
    while (element && element !== event.currentTarget) {
      const className = element.className || '';
      const classString = typeof className === 'string' ? className : className.toString();

      // If we find dropdown-related classes, don't start drag
      if (
        classString.includes('ant-dropdown') ||
        classString.includes('ant-select') ||
        classString.includes('h-full') ||
        classString.includes('relative parent-task') ||
        classString.includes('relative owner') ||
        classString.includes('bg-white shadow-md') ||
        classString.includes('ant-dropdown-menu')
      ) {
        return; // Don't start drag
      }

      element = element.parentElement as HTMLElement;
    }

    // If we get here, it's safe to start drag
    if (listeners?.onMouseDown) {
      listeners.onMouseDown(event);
    }
  };

  const dragHandleListeners = {
    ...listeners,
    onMouseDown: handleMouseDown,
  };

  return (
    <Form form={form} component={false}>
      {/*eslint-disable-next-line @typescript-eslint/no-unsafe-assignment*/}
      <tr {...props} ref={setNodeRef} style={style} {...attributes} {...dragHandleListeners} />
    </Form>
  );
});
